export default __webpack_public_path__ + "static/team-Amanda-fa3131e82b6f25b68da8549bfd1ebbcf.png";